$(document).ready(function () {
  "use strict";
  // navbar js start ---
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 10) {
      $(".navbar").addClass("nav-fixed");
    } else {
      $(".navbar").removeClass("nav-fixed");
    }
  });

  $(".ham-menu").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrapper").toggleClass("active");
    $(".ham-menu").toggleClass("active");
    $(".navbar-links-inner").toggleClass("active");
    $("body").toggleClass("active");
  });

  $(".mobile-menu-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".navbar-links-wrapper").removeClass("active");
    $(".ham-menu").removeClass("active");
    $(".navbar-links-inner").removeClass("active");
    $("body").removeClass("active");
  });

  // mobile-dropdown responsive accordion js start--
  $(function () {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 992px)"
    ).matches;

    if (isMobile) {
      // **..mobile-dropdown-accordion js start..**
      $(".navbar-link-title").on("click", function () {
        $(this).next(".navbar-link-content").slideToggle();
        $(this).parent().toggleClass("active");
      });
      // **..mobile-dropdown-accordion js end..**
    }

    // mobile-dropdown responsive accordion js start--
    $(function () {
      let isMobile = window.matchMedia(
        "only screen and (max-width: 992px)"
      ).matches;

      if (isMobile) {
        $(".dropdown-sub-menu").slideUp();
        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn1").on("click", function () {
          $(this).next(".dropdown-sub-menu1").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**

        // **..mobile-dropdown-accordion js start..**
        $(".dropdown-btn2").on("click", function () {
          $(this).next(".dropdown-sub-menu2").slideToggle();
          $(this).toggleClass("active");
        });
        // **..mobile-dropdown-accordion js end..**
      }
    });
    // mobile-dropdown responsive accordion js end--
  });
  // mobile-dropdown responsive accordion js end--

  $(".search-bar-open-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").addClass("active");
    $(".search-bar-close-window-btn").addClass("active");
    $("body").addClass("active");
  });

  $(".search-bar-close-window-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(this).removeClass("active");
    $("body").removeClass("active");
  });

  $(".search-close-btn").click(function (event) {
    event.stopPropagation();
    $(".search-bar-overlay").removeClass("active");
    $(".search-bar-close-window-btn").removeClass("active");
    $("body").removeClass("active");
  });

  // navbar js end ---

  // --grid-tab js start--
  $(".grid-tab-btn").click(function () {
    $(this).parent().siblings(".tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".grid-tab-content-item").hide();
    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // --grid-tab js end--

  // datepicker js start--
  $("#date").datepicker({
    showButtonPanel: true,
    showOtherMonths: true,
  });
  // datepicker js end--
});

// btn js ---
// primary btn---
$(function () {
  $(".primary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});

// secondary btn--
$(function () {
  $(".secondary-btn")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({
        top: relY,
        left: relX,
      });
    });
});
// btn js ---

// topbar slider js start--
var swiper = new Swiper(".top-bar-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
// topbar slider js end--

// text-slider2 js start--
var swiper = new Swiper(".text-slider2", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  effect: "cards",
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
});

// text-slider js start--
var swiper = new Swiper(".text-slider", {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  speed: 1000,
  effect: "cards",
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
});
// text-slider js end--

// event-slider js start--
var swiper = new Swiper(".event-slider", {
  slidesPerView: 3.2,
  spaceBetween: 64,
  grabCursor: true,
  loop: false,
  breakpoints: {
    // when window width is >= 1px
    1: {
      spaceBetween: 10,
      slidesPerView: 1.83,
    },
    // when window width is >= 430px
    576: {
      spaceBetween: 20,
      slidesPerView: 1.8,
    },
    // when window width is >= 767px
    768: {
      spaceBetween: 20,
      slidesPerView: 3.12,
    },
    // when window width is >= 767px
    993: {
      spaceBetween: 20,
      slidesPerView: 3.8,
    },
    1370: {
      spaceBetween: 70,
      slidesPerView: 3.8,
    },
  },
});
// event-slider js end--

// slider-tab js start---
// (initialised per-section in Slider-slide-tab.liquid)
// slider-tab js end---

// slider-tab2 js start---
// (initialised per-section in Slider-slide-tab.liquid)
// slider-tab2 js end---

// hero-swiper js start---
$(document).ready(function () {
  var heroSwiper = document.querySelector('.hero-swiper');
  if (heroSwiper) {
    new Swiper('.hero-swiper', {
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  }
});
// hero-swiper js end---
